import $ from "jquery/dist/jquery";

$(() => {
  $(document).on("nxcms:deliveryTypeModuleSelected", function (e, data) {
    if (!data.module) {
      return;
    }

    function selectedCallback(point) {
      const dataEl = $(
        'input[data-delivery-type-module="' + data.module + '"]'
      );
      const detailEl = dataEl
        .parents(".paymentgroup")
        .find(".delivery-module-detail");

      if (!point) {
        dataEl.attr("data-delivery-type-module-data", null);
        detailEl.text("");
        $('#selectDeliveryType input[type="radio"]').first().trigger("change");
        return;
      }

      dataEl.attr(
        "data-delivery-type-module-data",
        `${JSON.stringify(point)}^^^${point.name}`
      );
      detailEl.text(`${point.name} (${point.place})`);
      $('#selectDeliveryType input[type="radio"]').first().trigger("change");
    }

    function selectedCallbackHD(point) {
      const dataEl = $(
        'input[data-delivery-type-module="' + data.module + '"]'
      );
      const detailEl = dataEl
        .parents(".paymentgroup")
        .find(".delivery-module-detail");

      if (!point || !point.address) {
        dataEl.attr("data-delivery-type-module-data", null);
        detailEl.text("");
        $('#selectDeliveryType input[type="radio"]').first().trigger("change");
        return;
      }

      dataEl.attr(
        "data-delivery-type-module-data",
        `${JSON.stringify(point.address)}^^^${point.address.name}`
      );
      detailEl.text(`${point.address.name}`);
      $('#selectDeliveryType input[type="radio"]').first().trigger("change");
    }

    const d = data.module.split(":");
    if (d[0] == "zasilkovna") {
      const countryParts = d[1].split("-");
      const country = countryParts[0];
      const deliveryType = countryParts[1] ? countryParts[1] : "pickup";

      if (deliveryType === "HD") {
        const packetaOptions = {
          layout: "hd",
          carrierId: window.NXMOD.ZASILKOVNA_HD_CARRIER_ID,
          country: country.toLowerCase(),
        };
        console.warn(packetaOptions);
        window.Packeta.Widget.pick(
          window.NXMOD.ZASILKOVNA_API_KEY,
          selectedCallbackHD,
          packetaOptions
        );
      } else {
        const packetaOptions = {
          country: country.toLowerCase(),
        };
        window.Packeta.Widget.pick(
          window.NXMOD.ZASILKOVNA_API_KEY,
          selectedCallback,
          packetaOptions
        );
      }
    }
  });
});
